export default __webpack_public_path__ + "static/media/enaho.11558d0f.jpg";